export const transformClientDataFromOffice = (doc) => {
  if (!doc) throw Error("transformClientDataFromOffice | missing doc");
  return {
    ...doc,
    ipList: doc.ipList ? doc.ipList.split(",") : [],
    senderNumbers: doc.senderNumbers ? doc.senderNumbers.split(",") : [],
    selectedSenderNumber: doc.selectedSenderNumber || "",
    callbackUrl: doc.callbackUrl || "",
    callbackApiKey: doc.apiKey || "",
    accountType: doc.accountType || "",
    companyInfo: {
      ...doc.companyInfo,
      emailAddress: doc.companyInfo.billingEmail || "",
      regNr: doc.companyInfo.regNr || "",
      vatNr: doc.companyInfo.vatNr || "",
    },
  };
};

export const transformApiKeysDataFromOffice = (doc) => {
  if (!doc) throw Error("transformApiKeysDataFromOffice | missing doc");
  const transformedData = [];
  doc.forEach((element) => {
    if (!element.archived)
      transformedData.push({ id: element.id, key: element.key });
  });
  return transformedData;
};

export const transformUsagesDataFromOffice = (doc) => {
  if (!doc) throw Error("transformUsagesDataFromOffice | missing doc");
  // Support both array and single object responses
  const docsArray = Array.isArray(doc) ? doc : [doc];
  return docsArray.map((element) => {
    const usage = element.usage || {};
    return {
      id: `${element.year}-${element.month}`,
      month: element.month ?? usage.month,
      year: element.year ?? usage.year,
      deliveredSms: element.delivered?.sms ?? 0,
      deliveredViberMessages: element.delivered?.viber ?? 0,
      sentMessages: element.sent,
      periodStart: usage.periodStart,
      periodEnd: usage.periodEnd,
      totalCredits: usage.totalCredits ?? 0,
      currentSpentCredits: usage.currentSpentCredits ?? 0,
      smsPrice: usage.smsPrice ?? 0,
      viberPrice: usage.viberPrice ?? 0,
      currency: usage.currency ?? "",
      allowedSmsMessages: usage.allowedSmsMessages ?? 0,
      allowedViberMessages: usage.allowedViberMessages ?? 0,
    };
  });
};